import appIcon from '@/assets/download/head_icon.png';
import relatedIcon from '@/assets/app-store/related-icon.png';
import ui1 from '@/assets/app-store/ssOne.png';
import ui2 from '@/assets/app-store/ssTwo.png';
import similarOne from '@/assets/download/similarOne.png';
import similarTwo from '@/assets/download/similarTwo.png';
import similarThree from '@/assets/download/similarThree.png';

export interface AppReview {
  id: string;
  i18nKey: string;
  rating: number;
  comment: string;
}

export interface RelatedApp {
  id: string;
  i18nKey: string;
  icon: string;
  isAd?: boolean;
  installed?: boolean;
}

export interface PrivacyItem {
  i18nKey: string;
  icon: string;
}

export interface PrivacyCard {
  id: string;
  i18nKey: string;
  icon: 'track' | 'linked' | 'not-linked';
  items: PrivacyItem[];
}

export const appData = {
  icon: appIcon,
  hasInAppPurchases: true,
  stats: [
    { type: 'rating' as const, value: '4.8', labelKey: 'ratings' },
    { type: 'age' as const, value: '18+', subKey: 'years', labelKey: 'ageRating' },
    { type: 'chart' as const, value: 'No.85', subKey: 'music', labelKey: 'chart' },
    {
      type: 'developer' as const,
      labelKey: 'developer',
      avatar: relatedIcon,
    },
  ],
  screenshots: [
    { id: 's1', src: ui1 },
    { id: 's2', src: ui2 },
    // { id: 's3', src: ui1 },
  ],
  developer: { avatar: relatedIcon },
  ratings: {
    score: 4.8,
    outOf: 5,
    distribution: [
      { stars: 5, percentage: 82 },
      { stars: 4, percentage: 11 },
      { stars: 3, percentage: 4 },
      { stars: 2, percentage: 1 },
      { stars: 1, percentage: 2 },
    ],
  },
  reviews: [
    { id: 'r1', i18nKey: 'r1', rating: 5, comment:'download.commentOne' },
    { id: 'r2', i18nKey: 'r2', rating: 5, comment:'download.commentTwo' },
  ] as AppReview[],
  whatsNew: { version: '7.97.0' },
  privacy: {
    cards: [
      {
        id: 'track',
        i18nKey: 'track',
        icon: 'track' as const,
        items: [
          { i18nKey: 'location', icon: 'location-o' },
          { i18nKey: 'identifiers', icon: 'contact' },
          { i18nKey: 'usageData', icon: 'bar-chart-o' },
          { i18nKey: 'diagnostics', icon: 'setting-o' },
        ],
      },
      {
        id: 'linked',
        i18nKey: 'linked',
        icon: 'linked' as const,
        items: [
          { i18nKey: 'purchases', icon: 'shopping-cart-o' },
          { i18nKey: 'location', icon: 'location-o' },
          { i18nKey: 'identifiers', icon: 'contact' },
          { i18nKey: 'usageData', icon: 'bar-chart-o' },
          { i18nKey: 'diagnostics', icon: 'setting-o' },
        ],
      },
      {
        id: 'not-linked',
        i18nKey: 'notLinked',
        icon: 'not-linked' as const,
        items: [{ i18nKey: 'diagnostics', icon: 'setting-o' }],
      },
    ] as PrivacyCard[],
  },
  information: [
    { labelKey: 'provider', valueKey: 'developerName' },
    { labelKey: 'size', value: '76 MB' },
    { labelKey: 'category', valueKey: 'casino' },
    { labelKey: 'compatibility', valueKey: 'informationCompatibilityValue', expandable: true },
    { labelKey: 'languages', valueKey: 'informationLanguagesValue', expandable: true },
    { labelKey: 'ageRating', valueKey: 'informationAgeRatingValue', expandable: true },
    { labelKey: 'inAppPurchases', valueKey: 'yes', expandable: true },
    { labelKey: 'copyright', valueKey: 'informationCopyrightValue' },
  ] as Array<{
    labelKey: string;
    valueKey?: string;
    value?: string;
    expandable?: boolean;
  }>,
  externalLinks: [
    { i18nKey: 'developerWebsite', icon: 'guide-o' },
    { i18nKey: 'privacyPolicy', icon: 'shield-o' },
    { i18nKey: 'licenceAgreement', icon: 'description' },
  ],
  moreByDeveloper: {
    apps: [
      { id: 'm1', i18nKey: 'yousician', icon: relatedIcon, installed: true },
      { id: 'm2', i18nKey: 'piano', icon: relatedIcon },
    ] as RelatedApp[],
  },
  youMightAlsoLike: {
    apps: [
      { id: 'y1', i18nKey: 'tcg', icon: similarOne, isAd: true },
      { id: 'y2', i18nKey: 'doubletune', icon: similarTwo },
      { id: 'y3', i18nKey: 'guitarTunerEasy', icon: similarThree },
    ] as RelatedApp[],
  },
};

export type AppData = typeof appData;
